var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoticeBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 21.598l-8.425-8.4a.871.871 0 01-.212-.325 1.098 1.098 0 01-.063-.375 1.1 1.1 0 01.063-.375.872.872 0 01.212-.325l8.425-8.425c.233-.233.525-.35.875-.35s.65.125.9.375.375.542.375.875a1.2 1.2 0 01-.375.875l-7.35 7.35 7.35 7.35c.233.234.35.521.35.862 0 .342-.125.638-.375.888a1.2 1.2 0 01-.875.375 1.2 1.2 0 01-.875-.375z",
    fill: "#393E4C"
  })));
}

export default SvgNoticeBack;